import {SedestralProactive} from "../SedestralProactive";
import {ProactiveType} from "../types/ProactiveType";
import {txtNormalizeUrl} from "../../utilities/TxtNormalizeUrl";
import {config} from "../../../../config";

export class SedestralProactiveLivechat {

    private static readonly CHAT_OPENED_KEY = "sedestral_crisp_opened";
    private static helpCenterModeEnabled: boolean = false;

    public static async init(helpCenter?: boolean) {
        if (config.isWhiteLabel) return;
        window.$crisp = [];
        window.CRISP_WEBSITE_ID = "37d9b1e7-4745-4c0d-8c9e-d58083c21b6b";
        let d = document;
        let s = d.createElement("script") as any;
        s.src = "https://client.crisp.chat/l.js";
        s.async = 1;
        d.getElementsByTagName("head")[0].appendChild(s);


        this.registerAll();
        SedestralProactive.mainTriggerCallback = id => {
            $crisp.push(["do", "trigger:run", [id]]);
        }

        if (helpCenter) {
            this.helpCenterModeEnabled = true;
            $crisp.push(["on", "session:loaded", () => {
                // Vérifier que le mode est toujours activé
                if (!this.helpCenterModeEnabled) return;

                // Gérer l'état initial : cacher sauf si déjà ouvert
                const wasOpened = localStorage.getItem(this.CHAT_OPENED_KEY) === "true";
                if (wasOpened) {
                    this.openLiveChat();
                } else {
                    this.chatBoxHide();
                }

                // Écouter la fermeture du chat pour le cacher à nouveau
                $crisp.push(["on", "chat:closed", () => {
                    this.chatBoxHide();
                    localStorage.removeItem(this.CHAT_OPENED_KEY);
                }]);
            }]);
        }
    }

    public static chatBoxHide() {
        if (config.isWhiteLabel) return;
        $crisp.push(["do", "chat:hide"]);
        $crisp.push(["do", "chat:close"]);
    }

    public static chatBoxShow() {
        if (config.isWhiteLabel) return;
        $crisp.push(["do", "chat:show"]);
        $crisp.push(["do", "chat:close"]);
    }

    public static openLiveChat() {
        if (config.isWhiteLabel) return;
        $crisp.push(["do", "chat:show"]);
        $crisp.push(["do", "chat:open"]);
        localStorage.setItem(this.CHAT_OPENED_KEY, "true");
    }

    public static setUserName(userName: string) {
        if (config.isWhiteLabel) return;
        $crisp.push(["set", "user:nickname", userName]);
    }

    public static setUserEmail(userName: string) {
        if (config.isWhiteLabel) return;
        $crisp.push(["set", "user:email", userName]);
    }

    public static setUserCompany(name: string, website: string) {
        if (config.isWhiteLabel) return;
        $crisp.push(["set", "user:company", [name, {
            url: website ? txtNormalizeUrl(website) : undefined,
        }]]);
    }

    public static disableHelpCenterMode() {
        if (config.isWhiteLabel) return;
        if (!this.helpCenterModeEnabled) return;

        this.helpCenterModeEnabled = false;

        // Afficher le chat Crisp normal
        this.chatBoxShow();
        localStorage.removeItem(this.CHAT_OPENED_KEY);
    }

    public static enableHelpCenterMode() {
        if (config.isWhiteLabel) return;
        if (this.helpCenterModeEnabled) return;

        this.helpCenterModeEnabled = true;

        // Gérer l'état du chat : cacher sauf si déjà ouvert
        const wasOpened = localStorage.getItem(this.CHAT_OPENED_KEY) === "true";
        if (wasOpened) {
            this.openLiveChat();
        } else {
            this.chatBoxHide();
        }
    }

    private static registerAll() {
        SedestralProactive.register({
            id: 'blog',
            path: [
                {type: ProactiveType.PAGE_VIEW_COUNT, data: "/blog/*", count: 2},
                {type: ProactiveType.DELAY, data: 7000},
            ],
        });

        SedestralProactive.register({
            id: 'guide',
            path: [
                {type: ProactiveType.PAGE_VIEW_COUNT, data: "/guide/*", count: 2},
                {type: ProactiveType.DELAY, data: 7000},
            ],
        });

        SedestralProactive.register({
            id: 'pricing-scroll',
            path: [
                {type: ProactiveType.PAGE_VIEW, data: "/pricing"},
                {type: ProactiveType.SCROLL_DEPTH, data: 50, unit: "%"},
            ],
        });

        SedestralProactive.register({
            id: 'pricing-exit',
            path: [
                {type: ProactiveType.PAGE_VIEW, data: "/pricing"},
                {type: ProactiveType.EXIT_INTENT, data: "exit"},
            ],
        });

        SedestralProactive.register({
            id: 'pricing-change',
            path: [
                {type: ProactiveType.PAGE_VIEW, data: "/pricing"},
                {type: ProactiveType.PAGE_VIEW, data: "*"},
            ],
        });

        SedestralProactive.register({
            id: 'audit_campain',
            path: [
                {type: ProactiveType.CUSTOM_EVENT, data: "audit_campain"},
                {type: ProactiveType.DELAY, data: 7000},
            ],
        });
    }
}